import { useEffect, useState } from "react";

export default () => {
    const [scrollDirection, setScrollDirection] = useState("");

    useEffect(() => {
        let lastScrollY = window.pageYOffset;

        const updateScrollDirection = () => {
            const scrollY = window.pageYOffset;
            const direction = scrollY > lastScrollY ? "SCROLL_DOWN" : "SCROLL_UP";

            if (direction !== scrollDirection && (scrollY - lastScrollY > 0 || scrollY - lastScrollY < -0)) {
                setScrollDirection(direction);
            }
            lastScrollY = scrollY > 0 ? scrollY : 0;
        };

        window.addEventListener("scroll", updateScrollDirection);

        return () => {
            window.removeEventListener("scroll", updateScrollDirection);
        };
    }, [scrollDirection]);

    return { scrollDirection };
};
